import { Copy, Flex, Heading, Stack } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookCheckboxWrapper } from 'src/components/CookbookCheckboxWrapper/CookbookCheckboxWrapper';

export interface PGPEncryptionControlProps {
  name: string;
  id: string;
  heading: string;
  body: string;
}

export function PGPEncryptionControl({
  name,
  id,
  heading,
  body,
}: PGPEncryptionControlProps): JSX.Element {
  const { control } = useFormContext();
  return (
    <>
      <Flex flexDirection="column">
        <Stack y="x-sm">
          <Heading variant="h6">{heading}</Heading>
        </Stack>
        <Stack y="x-sm">
          <Copy variant="body">{body}</Copy>
        </Stack>
        <Stack y="x-sm">
          <CookbookCheckboxWrapper
            control={control}
            id={id}
            name={name}
            label="Yes"
          />
        </Stack>
      </Flex>
    </>
  );
}
